// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"801ee498","455":"d2ff4db8","977":"7e47a2a2"}[chunkId] + ".chunk.js";
};